import { Navigate, Outlet, useLocation } from 'react-router'
import { useMe } from '../hooks/useMe'
import { useAuthStatus } from '../api/auth-listener'
import WelcomeProfileEdit from './WelcomeProfileEdit'

const AuthRedirect: React.FC = () => {
  const is_auth = useAuthStatus() === 'authenticated'
  const location = useLocation()
  const search_params = new URLSearchParams({
    from: location.pathname + location.search
  })
  const me = useMe()
  // useLocationやNavigateを用いるためにhook/meではなくここでリダイレクト
  const redirect_edit_profile = me && !me.user_name && location.pathname !== '/edit_profile'
  return is_auth ?
    redirect_edit_profile ?
      <WelcomeProfileEdit/>
    :
      <Outlet/>
  :
    <Navigate replace to={location.pathname === '/' ? '/about' : `/login?${search_params}`}/>
}
export default AuthRedirect